import logoImage from "../../assest/images/logo-img.png"
import { Link, useSearchParams } from "react-router-dom"
import helper from "../../common/Helper";
import ProviderList from "../../components/ProviderList"


const IntegrationRequested = () => {
    const [searchParams] = useSearchParams();

    return (
        <div className="sq-wrapper">
            <div className="sq-left">
                <a href={helper.touristUrl} target="_blank"><img src={logoImage} alt="logo-img" className="logo-img" /></a>
                <div className="sq-form-section">
                    <h1 className="sq-heading">Thank you for your interest in ToursXplorer
                    </h1>
                    <div>We currently don't support <b>{searchParams.get("provider_name")}</b>.

                        We've received your request and will review the possibility of integrating with this provider. We'll contact you at <b>{searchParams.get("email")}</b> if support becomes available.</div>
                </div>
            </div>

            <div className="sq-right">

                <div className="sq-right-content">
                    <h2 className="sq-hero-title">Welcome to the<br /> Supplier Portal</h2>

                    <div className="sq-quote-block">
                        <p className="sq-quote-text">Simplify tour management, monitor real-time reservations, and keep your explorers prepared for their next thrill. Everything you need to organize, grow, and scale your adventure offerings: all in one place.</p>
                    </div>
                </div>

                <div className="sq-logos-section">
                    <div className="sq-logos-divider"></div>
                    <div className="sq-logos-label">We work with</div>
                    <div className="sq-logos-row">
                        <ProviderList />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default IntegrationRequested;